import { render, staticRenderFns } from "./v3_mobile.vue?vue&type=template&id=06fa7de9&scoped=true&"
import script from "./v3_mobile.vue?vue&type=script&lang=js&"
export * from "./v3_mobile.vue?vue&type=script&lang=js&"
import style0 from "./v3_mobile.vue?vue&type=style&index=0&id=06fa7de9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fa7de9",
  null
  
)

export default component.exports